var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20318 0.998831L7.25023 0.997574L7.29598 0.998782C7.31841 1.00008 7.3409 1.00241 7.36336 1.00581L7.37944 1.00962C7.46485 1.02334 7.54972 1.05384 7.63062 1.10177L7.68249 1.13531L12.7528 4.70057L17.8198 1.13866C18.2876 0.809863 18.9213 1.10539 18.9942 1.64773L19.0012 1.75222V12.3848C19.0012 12.5941 18.9138 12.7922 18.763 12.9329L18.6825 12.9983L13.1825 16.8647C12.9156 17.0523 12.5946 17.0366 12.3547 16.8878L7.24983 13.2966L2.18015 16.8613C1.71244 17.1901 1.0787 16.8946 1.00576 16.3523L0.998829 16.2478V5.61525C0.998829 5.40593 1.08618 5.20784 1.23695 5.06708L1.31751 5.00168L6.81751 1.13531C6.88151 1.09032 6.94862 1.05702 7.01698 1.03444L7.13945 1.00643L7.20318 0.998831ZM17.5012 3.19623L13.5012 6.00814V14.8071L17.5012 11.9952V3.19623ZM6.49883 3.19288L2.49883 6.00479V14.8038L6.49883 11.9919V3.19288ZM8.00117 3.19288V11.9919L12.0012 14.8038V6.00479L8.00117 3.19288Z",
    fill: "#5CB1A3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.64e02d471e5b6319660c1d9ca1237572.svg";
export { ForwardRef as ReactComponent };